import React from "react";

const Header = ({ onAdd}) => {
 

  return (
    <>
      <div className="z-1">
        <div className="d-flex justify-content-between align-items-center p-4">
          <h1 className="font-24 font-weight-s-bold m-0">Tasks</h1>
          <div className="d-flex gap-2">
            
            <button className="add-new-btn" onClick={() => onAdd()}>
              <img
                className="me-2 add-user-icon"
                src="/assets/images/add-icon.svg"
                alt="Add New"
              />
              Add Task
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
